import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function ClipboardIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0H11V4H5V0ZM12 1H15C15.6 1 16 1.4 16 2V15C16 15.6 15.6 16 15 16H1C0.4 16 0 15.6 0 15V2C0 1.4 0.4 1 1 1H4V3H2V14H14V3H12V1ZM4 7C4 6.44772 4.44772 6 5 6H11C11.5523 6 12 6.44772 12 7C12 7.55228 11.5523 8 11 8H5C4.44772 8 4 7.55228 4 7ZM5 10C4.44772 10 4 10.4477 4 11C4 11.5523 4.44772 12 5 12H11C11.5523 12 12 11.5523 12 11C12 10.4477 11.5523 10 11 10H5Z"
        />
      </svg>
    </Icon>
  );
}
